import { Component, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Icons } from 'src/app/models/icons.model';
import { SiteModel } from 'src/app/models/site.model';

@Component({
  selector: 'app-admin-site-picker',
  standalone: false,
  templateUrl: './site-picker.component.html',
  styleUrls: ['./site-picker.component.scss'],
})
export class SitePickerComponent implements OnInit {
  @Input()
  set sites(value: SiteModel[]) {
    this._sites = value;
    this.initSearch();
  }
  @Input()
  isReady: boolean = true;
  @Input()
  caption: string = 'Select Sites';

  _sites: SiteModel[];

  icons = new Icons();
  filteredSites: Observable<SiteModel[]>;
  filter = new UntypedFormControl('');

  constructor() { }

  ngOnInit(): void {
    this.initSearch();
  }

  selectAll() {
    this._sites.forEach((s) => (s.IsSelected = true));
  }

  selectNone() {
    this._sites.forEach((s) => (s.IsSelected = false));
  }

  private initSearch() {
    this.filteredSites = this.filter.valueChanges.pipe(
      startWith(''),
      map((text) => this.searchUsers(text))
    );
  }

  clearSearch() {
    this.filter.setValue('');
  }

  private searchUsers(text: string): SiteModel[] {
    return this._sites?.filter((user) => {
      const term = text.toLowerCase();
      return user.Name?.toLowerCase().includes(term);
    });
  }
}
